export const RESET_PASSWORD_FORM_PASSWORD_PLACEHOLDER = 'reset-password-form.password-placeholder';
export const RESET_PASSWORD_FORM_CONFIRM_PASSWORD_PLACEHOLDER = 'reset-password-form.confirm-password-placeholder';
export const RESET_PASSWORD_FORM_PASSWORD_INVALID_ERROR_MESSAGE = 'reset-password-form.password-invalid-error-message';
export const RESET_PASSWORD_FORM_PASSWORDS_NOT_MATCH_ERROR_MESSAGE = 'reset-password-form.passwords-not-match-error-message';
export const RESET_PASSWORD_FORM_SUBMIT_BUTTON_LABEL = 'reset-password-form.submit-button-label';
